import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, CircularProgress, Fade, Typography, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { subscribeLoading } from "../../Utils/loadingManager";

export default function GlobalLoading() {
  const { t } = useTranslation();
  const theme = useTheme();
  const [visible, setVisible] = useState(false);

  const primary = theme.palette.primary.main;
  const nav = theme.palette.nav?.main ?? "#000922";
  const accent = theme.palette.info.main;

  useEffect(() => subscribeLoading(setVisible), []);

  return (
    <Fade in={visible} timeout={220} unmountOnExit>
      <Box
        role="status"
        aria-live="polite"
        aria-busy="true"
        aria-label={t("loading")}
        sx={{
          position: "fixed",
          inset: 0,
          zIndex: 9999,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: alpha(nav, 0.42),
          backdropFilter: "blur(6px)",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
            px: 4,
            py: 3.5,
            borderRadius: 3,
            bgcolor: alpha("#fff", 0.96),
            border: `1px solid ${alpha("#fff", 0.8)}`,
            boxShadow: `0 24px 48px ${alpha(nav, 0.28)}`,
            minWidth: 160,
          }}
        >
          <Box
            sx={{
              position: "relative",
              width: 48,
              height: 48,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                position: "absolute",
                inset: 0,
                borderRadius: "50%",
                border: `4px solid ${alpha(primary, 0.14)}`,
              }}
            />
            <CircularProgress
              size={48}
              thickness={4}
              sx={{ color: accent, animationDuration: "900ms" }}
            />
          </Box>
          <Typography
            variant="body2"
            fontWeight={600}
            sx={{ color: primary, letterSpacing: "0.02em" }}
          >
            {t("loading")}
          </Typography>
        </Box>
      </Box>
    </Fade>
  );
}
